import script from "./SoftDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftDialog.vue?vue&type=script&setup=true&lang=js"

import "./SoftDialog.vue?vue&type=style&index=0&id=7f590e9d&lang=less"

const __exports__ = script;

export default __exports__